<button class="make-payment__card">
  <img 
    class="card__logo"
    src="/assets/imgs/mpass-logo.svg" 
    [alt]="'MPASS logo' | translate"
  >
  
  <div class="card__content">
    <p class="card__title ci-paragraph-p1-semibold">
      {{ 'Haz click para iniciar sesión' | translate }}
    </p>
    
    <p class="card__subtitle ci-caption-regular">
      {{ 'Necesitas iniciar sesión en MPASS para poder realizar pagos' | translate }}
    </p>
  </div>
</button>